import { TestPaymentCards } from '@wix/payments-common';
import { type CardData } from '../../components/CardForm/types';
import { transformExpireStrToObj } from '../../components/CardForm/utils/formatting';
import { ErrorMessage } from '../../types/ErrorMessage';
import { TokenizationErrorCodes } from '../../types/TokenizationErrorCodes';
import { type TokenizeResponse } from '../../types/TokenizeResponse';
import { filterDefined } from '../../utils/filterDefined';
import { type MessageResponse } from '../../utils/messages/types';

const supportedTestCardNumbers: string[] = Object.values(TestPaymentCards);

// Tokens must be GUID-shaped (the backend TestCreditCardGateway consumes token GUIDs), and the
// approved/declined outcome is derived from the PAN's last 4 digits embedded in the token — so
// the cards in TestPaymentCards must stay distinguishable by their last 4 digits.
const testTokenPrefix = '00000000-0000-0000-0000-00000000';

export const tokenizeTestCard = (cardData: CardData): MessageResponse<TokenizeResponse> => {
  if (!supportedTestCardNumbers.includes(cardData.number)) {
    return {
      error: {
        message: ErrorMessage.InvalidCard,
        errorCode: TokenizationErrorCodes.NonTestCardInTestMode,
        details: 'Only predefined test cards are supported',
      },
    };
  }

  return filterDefined({
    numberToken: `${testTokenPrefix}${cardData.number.slice(-4)}`,
    holderName: cardData.holderName,
    expiration: cardData.expiration ? transformExpireStrToObj(cardData.expiration) : undefined,
  });
};
